module.exports = __webpack_public_path__ + "static/media/zwz.4f35eca0.png";